import { TimelineDeposit } from './response.types'

/** Причина, по которой депозит не получил выплату, хотя выплаты в пуле были. */
const NO_PAYOUT_REASON_LABEL: Record<string, string> = {
  requisite_repeat_limit: 'повтор реквизита',
}

/** Подпись причины отказа депозита группы «Не нашёл выплату»; null — обычная нехватка выплат. */
export function noPayoutReasonLabel(
  deposit: Pick<TimelineDeposit, 'group' | 'reason'>
): string | null {
  if (deposit.group !== 'no_payout' || !deposit.reason) {
    return null
  }
  return NO_PAYOUT_REASON_LABEL[deposit.reason] ?? deposit.reason
}
